import React, { useState, useEffect } from "react";
import './LeadsUpdatedVersion.css';
import axios from "axios";
import { decryptToken } from "../utils/getToken";

const RatingComponent = ({ inquiryId, mark, leadsDataRatingMain, updateLead }) => {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [submitted, setSubmitted] = useState(false);
    const [showOptions, setShowOptions] = useState(false);
    const [checkRating, setCheckRating] = useState(false);
    const url = process.env.REACT_APP_LINK
    const token = decryptToken("accessToken") || ""

    useEffect(() => {
        if (rating > 0) {
            const timer = setTimeout(() => {
                setShowOptions(true); // Show options after 3 seconds
            }, 500);
            return () => clearTimeout(timer); // Cleanup timeout
        }
    }, [rating]);

    const handleStarClick = async (star) => {
        setRating(star);
        setShowOptions(false);

        try {
            const response = await axios.put(`${url}/leads/change/${inquiryId}`, {
                rating: star,
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            if (response.status === 200) {
                updateLead(inquiryId, { rating: star });
            }
        } catch (error) {
            console.error("Error updating rating:", error);
        }
    };

    const handleSelection = async (option) => {
        try {
            const response = await axios.put(`${url}/leads/change/${inquiryId}`, {
                rate_message: option,
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            // if(response.ok){
            if (response.status === 200) {
                fetchSingleRating();
                updateLead(inquiryId, { rate_message: option });
                // leadsDataRatingMain();
                setSubmitted(true);
            }
        } catch (error) {
            console.error("Error updating rate message:", error);
        }
    };

    const fetchSingleRating = async () => {
        try {
            const response = await fetch(`${url}/leads/${inquiryId}`,{
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const res = await response.json();
            if (res.rating && res.rate_message) {
                setCheckRating(true)
            } else {
                setCheckRating(false);
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        fetchSingleRating();
    }, [inquiryId])

    return (
        <div className="rating-container">
            <span>How useful was this enquiry?</span>

            {/* Show Stars Only if Options Are Not Visible */}
            {!checkRating && !showOptions && (
                <div className="stars">
                    {[1, 2, 3, 4, 5].map((star) => (
                        <i
                            key={star}
                            className={`fa-star ${star <= (hover || rating) ? "fas" : "far"}`}
                            onMouseEnter={() => setHover(star)}
                            onMouseLeave={() => setHover(0)}
                            onClick={() => handleStarClick(star)}
                        ></i>
                    ))}
                </div>
            )}

            {/* Show Radio Options After 3-sec Delay */}
            {rating > 0 && showOptions && !checkRating && (
                <>
                    {rating <= 3 && (
                        <div className="radio-options">
                            {["Not Interested", "Not Contactable", "Wrong category", "Out of area", "Marketing/Job"].map(
                                (option) => (
                                    <div key={option}>
                                        <input
                                            type="radio"
                                            id={option}
                                            name="feedback"
                                            value={option}
                                            onChange={() => handleSelection(option)}
                                        />
                                        <label htmlFor={option}>{option}</label>
                                    </div>
                                )
                            )}
                        </div>
                    )}

                    {rating >= 4 && (
                        <div className="radio-options">
                            {["Great Enquiry", "High Potential", "Close to Conversion"].map(
                                (option) => (
                                    <div key={option}>
                                        <input
                                            type="radio"
                                            id={option}
                                            name="feedback"
                                            value={option}
                                            onChange={() => handleSelection(option)}
                                        />
                                        <label htmlFor={option}>{option}</label>
                                    </div>
                                )
                            )}
                        </div>
                    )}
                </>
            )}

            {/* Thank You Message */}
            {checkRating && (
                <div className="thank-you">
                    <p>Thank you for your feedback! We appreciate it.</p>
                </div>
            )}
        </div>
    );
};

export default RatingComponent;
